import { Text } from 'farmhub-ui-core';

import { Wrapper } from './styles';

type NewFeatureTagProps = {
  text: string;
};

const NewFeatureTag = ({ text }: NewFeatureTagProps) => (
  <Wrapper>
    <Text color="white" size="tiny" weight="bold">
      {text}
    </Text>
  </Wrapper>
);

export default NewFeatureTag;
